/* global THREE */
import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";

const v1 = new THREE.Vector3();
const v2 = new THREE.Vector3();

const m1 = new THREE.Matrix4();

/*
const createAmmoEl = () => {
  const ammoEl = instantiate(`
      <a-entity ammo="count:10;max:10" gltf-blender-part="part:missile-silo-ammo;src:./assets/game-actors/game-actors.gltf;findMesh:false">
      </a-entity>
    `);
  return ammoEl;
};
*/

aframe.registerComponent("missile-silo", {
  schema: {
    missileSpeed: { type: "number", default: 0.3 }
  },
  init() {
    this.ammoEl = this.el;
    this.el.setAttribute("ammo", { count: 10, max: 10 });

    this.gameEl = document.querySelector("#game-board");
    this.fireFromEl = this.el.querySelector(".fireFrom");
    this.isDestroyed = false;
    this.meshEl = this.el.querySelector(".live");
    this.destroyedEl = this.el.querySelector(".destroyed");
  },
  fireAt(worldPosition) {
    if (!this.canFire()) {
      return;
    }

    if ("omega-turret-tracking" in this.el.components) {
      this.el.components["omega-turret-tracking"].trackWorldLocation(
        worldPosition
      );
    }

    const start = this.gameEl.object3D.worldToLocal(
      this.fireFromEl.object3D.getWorldPosition(v1)
    );
    const end = this.gameEl.object3D.worldToLocal(v2.copy(worldPosition));
    const distance = start.distanceTo(end);
    const rotation = m1.lookAt(start, end, this.gameEl.object3D.up);
    const missileConfig = {
      speed: this.data.missileSpeed,
      color: "blue",
      distance: distance,
      isPlayer: true
    };
    const missileEl = this.el.sceneEl.systems.missile.spawn(
      missileConfig,
      start,
      rotation
    );
    // const crosshairEl = this.el.sceneEl.systems.crosshair.spawn(missileEl, end);
    this.el.sceneEl.systems.crosshair.spawn(missileEl, end);

    this.fireFromEl.components.misound.playSound();

    // const { count, max } = this.ammoEl.getAttribute("ammo");
    const { count } = this.ammoEl.getAttribute("ammo");
    this.ammoEl.setAttribute("ammo", { count: count - 1 });
    const low = 4;
    if (count === low) {
      this.lowAmmoAlert();
    } else if (count === 1) {
      this.outOfAmmo();
    }
  },
  canFire() {
    return this.ammoEl.getAttribute("ammo").count > 0 && !this.isDestroyed;
  },
  outOfAmmo() {
    if (this.outOfAmmoObject) {
      this.outOfAmmoObject.visible = true;
    }
    if (this.lowAmmoObject) {
      this.lowAmmoObject.visible = false;
    }
  },
  lowAmmoAlert() {
    if (this.lowAmmoObject) {
      this.lowAmmoObject.visible = true;
    }
    this.el.components.misound.playSound();
  },
  reset(shouldOpen) {
    this.meshEl.object3D.visible = true;
    this.destroyedEl.object3D.visible = false;
    this.ammoEl.setAttribute(
      "ammo",
      "count",
      this.ammoEl.getAttribute("ammo").max
    );
    this.isDestroyed = false;

    if (this.lowAmmoObject) {
      this.lowAmmoObject.visible = false;
    }
    if (this.outOfAmmoObject) {
      this.outOfAmmoObject.visible = false;
    }

    if (!this.isOpen && shouldOpen) {
      this.isOpen = true;
      this.playAnim();
    } else if (!shouldOpen) {
      this.stopAnim();
      this.isOpen = false;
    }
  },
  destroyed() {
    this.meshEl.object3D.visible = false;
    this.destroyedEl.object3D.visible = true;
    this.ammoEl.setAttribute("ammo", { count: 0 });
    this.isDestroyed = true;
    this.isOpen = false;
  },
  playAnim() {
    if (!this.clip) {
      if (!this.meshEl.object3D.children.length) {
        console.error("Couldnt get animations");
        return;
      }
      const anims = this.meshEl.object3D.children[0].__animations;
      if (!anims) {
        console.error("Couldnt get animations");
        return;
      }
      const anim = anims[0];
      this.mixer = new THREE.AnimationMixer(this.meshEl.object3D.children[0]);
      this.clip = this.mixer.clipAction(anim);
      this.clip.loop = THREE.LoopOnce;
      this.clip.clampWhenFinished = true;
    }
    this.clip.reset();
    this.clip.play();
  },
  stopAnim() {
    if (this.clip) {
      this.clip.stop();
    }
  },
  tick(t, dt) {
    if (this.mixer) {
      this.mixer.update(dt / 1000);
    }
  },
  collisionstart: bindEvent(function (evt) {
    this.destroyed();
  }),
  gamestatechanged: bindEvent({ target: "[game-state]" }, function (evt) {
    const newState = evt.detail;
    if (
      newState === "MainMenu" ||
      newState === "StartNextLevel" ||
      newState === "NewGame"
    ) {
      this.reset(newState !== "MainMenu");
    } else if (newState === "GameOver") {
      this.destroyed();
    }
  }),
  "model-loaded": bindEvent(function (evt) {
    this.lowAmmoObject = this.meshEl.object3D.getObjectByName("low-ammo-alert");
    if (this.lowAmmoObject) {
      this.lowAmmoObject.visible = false;
    }
    this.outOfAmmoObject = this.meshEl.object3D.getObjectByName("out-of-ammo");
    if (this.outOfAmmoObject) {
      this.outOfAmmoObject.visible = false;
    }
  })
});
